<template>
 <div class="card" v-if="section.name" :class="{
  'disabled has-background-grey-light' : sectionDisabled
  }">
    <div class="card-header">
      <div class="column">
        <div class="columns">
          <div class="column">
            <b-icon icon="arrows-up-down-left-right" />
            Áreas de desarrollo
          </div>
          <div class="column has-text-right">
            Mostrar sección:
            <b-switch  :aria-disabled="sectionDisabled" :disabled="sectionDisabled" v-model="section.devAreas.active" @input="updateSection" />
          </div>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="pb-15">
        <b-field label="Descripción">
          <b-input 
            v-model="section.devAreas.description"
            placeholder="Ejem. Nuestra empresa te ofrece un desarrollo gigante" 
            @blur="updateSection"
            disabled = "sectionDisabled"
            :class="{'disabled-input': sectionDisabled}"
          />
        </b-field>
      </div>
      <div v-for="(dev, index) in section.devAreas.devAreas" :key="index">
        <div class="columns">
          <div class="column">
            <b-field label="Áreas de desarrollo de la empresa">
              <b-input 
                v-model="dev.text" 
                placeholder="¿Cuáles son las áreas de desarrollo?"
                @blur="updateSection"
              />
            </b-field>
            <b-field label="Descripción">
              <b-input 
                v-model="dev.description" 
                placeholder="Ingresa un texto corto" 
                @blur="updateSection"
              />
            </b-field>
            <b-field class="file">
              <b-upload v-model="dev.file" accept="image/*" @input="uploadLocalImage(dev, index)">
                <a class="button is-primary">
                  <b-icon icon="upload" />
                  <span>Subir imagen (272px x 386px)</span>
                </a>
              </b-upload>
              <span v-if="dev.image" class="file-name">
                {{ dev.image.url }}
                <button class="delete is-small" type="button" @click="deleteLocalImage(dev)">
                </button>
              </span>
            </b-field>
          </div>
          <div class="column">
            <div class="buttons" style="justify-content: flex-end">
              <b-button type="is-danger" icon-right="trash" @click="removeDevArea(index)" />
            </div>
          </div>
        </div>
        <hr>
      </div>
      <b-button @click="addDevArea" aria-disabled="sectionDisabled" disabled="sectionDisabled">
        Agregar área de desarrollo
      </b-button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    defaultSection: {
      type: Object,
    },
    uploadImage: {
      type: Function,
    },
    deleteImage: {
      type: Function,
    },
    sectionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      section: {},
      isLoading: false,
    }
  },
  mounted() {
    this.section = {...this.defaultSection};
  },
  watch: {
    defaultSection: {
      handler: function (val) {
        this.section = {...val }
      }
    },
  },
  methods: {
    updateSection() {
      this.$emit('updateSection', this.section)
    },
    async uploadLocalImage(slide, index){
      this.isLoading = true;
      const file = slide.file;
      const fileIdentifier = `devArea-${index + 1}`;
      const fileMetadata = slide.image;
      slide.image = await this.uploadImage(file, fileIdentifier, fileMetadata);

      this.updateSection();
      this.isLoading = false;
    },
    async deleteLocalImage(slide){
      this.isLoading = true;
      slide.image = await this.deleteImage(slide.image.key);

      this.updateSection();
      this.isLoading = false;
    },
    addDevArea() {
      this.section.devAreas.devAreas.push({ text: '', file: null, image: {url: '', tag:'', key: ''}, description: '' })
      this.updateSection()
    },
    removeDevArea(index) {
      if (this.section.devAreas.devAreas[index].image?.key) 
        this.deleteLocalImage(this.section.devAreas.devAreas[index])

      this.section.devAreas.devAreas.splice(index, 1)
      this.updateSection()
    },
  }
}
</script>

<style scoped>
.loading-wrapper{
    position: relative;
    min-height: 300px;
  }
</style>
